// office-ui-fabric-react@6.182.1
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
import { setVersion } from '@uifabric/set-version';
setVersion('office-ui-fabric-react', '6.182.1');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/version.js
// module id = 137
// module chunks = 0